<template>
  <div class="image-uploader border-2 border-dashed border-gray-300 rounded p-4 mb-3">
    <div v-if="!imageData" class="flex flex-col items-center">
      <label class="flex flex-col items-center cursor-pointer">
        <span class="text-sm text-gray-600 font-semibold">{{ label }}</span>
        <input
          type="file"
          accept="image/*"
          @change="handleFileUpload"
          class="hidden"
        />
      </label>
    </div>

    <div v-else class="flex flex-col items-center">
      <img
        :src="imageData"
        :alt="label"
        class="max-w-xs max-h-40 rounded mb-2 object-cover"
      />
      <button
        type="button"
        @click="removeImage"
        class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-3 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
      >
        Удалить изображение
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Загрузить изображение',
    },
    initialImage: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      imageData: this.initialImage || null,
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Проверка размера (макс 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Размер файла не должен превышать 5MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageData = e.target.result;
        // Emit base64 строку родителю
        this.$emit('image-uploaded', this.imageData);
      };
      reader.readAsDataURL(file);
    },

    removeImage() {
      this.imageData = null;
      this.$emit('image-removed');
    },

    getImageData() {
      return this.imageData;
    },
  },
};
</script>

<style scoped>
.image-uploader {
  transition: all 0.3s ease;
}

.image-uploader:hover {
  border-color: #3b82f6;
  background-color: #f0f9ff;
}
</style>
